import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import SearchBar from '@/components/SearchV3/index.vue';
import searchMixin from '@/mixin/search';
import AuthorizeRecordsTable from './mixin/authorize-records-table.js';
import AuthorizeDialog from './authorize-dialog/index.vue';
import Pagination from '@/components/Pagination/index.vue';
import { fetchGrantRecords, fetchGrantPlans } from '@/api/grant/grant';
import { format } from 'date-fns';
import { v2Host } from '@/config/host';
import { downloadWithNewWindow } from '@/common/download.js';
import TableList from '@/components/TableList/index.vue';
import qs from 'qs';
import AuthorizeFilterList from './mixin/authorize-filter-list';
import ListTooltipCell from './components/list-tooltip-cell.vue';

export default {
  components: {
    SearchBar: SearchBar,
    AuthorizeDialog: AuthorizeDialog,
    Pagination: Pagination,
    TableList: TableList,
    ListTooltipCell: ListTooltipCell
  },
  mixins: [searchMixin, AuthorizeRecordsTable, AuthorizeFilterList],
  data: function data() {
    return {
      listLoading: true,
      query: {
        page: 1,
        page_size: 15,
        adv_id: '',
        adv_ids: [],
        template_ids: [],
        channel_ids: [],
        status: '',
        account_type: '',
        subscribe_type: '',
        free: '', // 1是 2否 0全部
        order: '-created_time',
        is_test: ''
      },
      pagination: {
        total: 0
      },
      // 表单数据
      list: [],
      currentAuthorizeInfo: {},
      addDialog: {
        visible: false
      },
      subscribeTypes: [],
      demoMaxPushCount: 0,
      planList: []
    };
  },

  computed: {
    exportButtonAttrs: function exportButtonAttrs() {
      return {
        icon: 'el-icon-fa-download',
        type: 'primary'
      };
    }
  },
  watch: {
    $route: function $route(to, from) {
      if (this.query.template_ids.length) {
        this.setTemplateInitData();
      }
      if (this.query.channel_ids.length) {
        this.query.channel_ids = this.query.channel_ids.map(function (val) {
          return val.toString();
        });
      }
      if (this.query.admin_ids.length) {
        this.query.admin_ids = this.query.admin_ids.map(function (val) {
          return val.toString();
        });
      }
      this.getGrantList(this.query);
    }
  },
  methods: {
    handleSortChange: function handleSortChange(sort) {
      if (sort.order === 'descending') {
        this.query.order = '-created_time';
      } else if (sort.order === 'ascending') {
        this.query.order = 'created_time';
      } else {
        this.query.order = '';
      }
      this.getGrantList(this.query);
    },
    setTemplateInitData: function setTemplateInitData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getTemplateList({
                  ids: _this.query.template_ids
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getGrantList: function getGrantList(params) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.listLoading = true;
                _context2.next = 3;
                return fetchGrantRecords(_extends({}, params, {
                  free: !params.free ? 0 : params.free
                }));

              case 3:
                res = _context2.sent;

                _this2.listLoading = false;

                if (!(res.status !== 200)) {
                  _context2.next = 8;
                  break;
                }

                _this2.$message.error('出错了');
                return _context2.abrupt('return');

              case 8:
                _this2.list = _this2.cookList(res);
                _this2.pagination.total = _.get(res, 'data.data.total');

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    exportSheet: function exportSheet() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                try {
                  downloadWithNewWindow(v2Host + '/grant/export-detail?' + qs.stringify(_this3.query, {
                    indices: false
                  }));
                } catch (error) {
                  console.log(error);
                }

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    showAddDialog: function showAddDialog() {
      this.currentAuthorizeInfo = {};
      this.addDialog.visible = true;
    },
    cookList: function cookList(res) {
      var list = (_.get(res, 'data.data.list') || []).map(function (item) {
        return _extends({}, item, {
          updated_time: format(item.updated_time * 1000, 'YYYY-MM-DD HH:mm:ss'),
          effective_time: item.effective_time ? format(item.effective_time * 1000, 'YYYY-MM-DD HH:mm:ss') : '-',
          created_time: format(item.created_time * 1000, 'YYYY-MM-DD HH:mm:ss'),
          expired_time: item.expired_time ? format(item.expired_time * 1000, 'YYYY-MM-DD HH:mm:ss') : '-',
          plan_settings: item.plan_settings ? item.plan_settings : {}
        });
      });

      return list;
    },
    handleSaveAuthorizeSuccess: function handleSaveAuthorizeSuccess() {
      this.getGrantList(this.query);
    },
    getPackageConfig: function getPackageConfig() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return _this4.$store.dispatch('config/getGrantConfig');

              case 3:
                res = _context4.sent;

                _this4.subscribeTypes = _.get(res, 'subscribe_types');
                _this4.demoMaxPushCount = _.get(res, 'trial_account_max_push_count');
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](0);

                console.log(_context4.t0);

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 8]]);
      }))();
    },
    handleReload: function handleReload() {
      this.getGrantList(this.query);
    },
    getPlanList: function getPlanList() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var res;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return fetchGrantPlans({
                  // grant_type: this.formValue.grant_type,
                });

              case 2:
                res = _context5.sent;


                _this5.planList = (_.get(res, 'data.data') || []).map(function (item) {
                  return _extends({}, item, {
                    value: item.id,
                    label: item.name
                  });
                });

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  },

  mounted: function mounted() {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this6.getPackageConfig();

            case 2:
              _this6.getGrantList(_this6.query);
              _this6.setTemplateInitData();
              _this6.getOptionChannels();
              _this6.getPlanList();
              _this6.getOperator();

            case 7:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
};